$(document).ready(function () {
  $(".slider-main").slick({
    slidesToShow: 1,
    arrows: true,
    infinite: false,
    lazyLoad: true,
    prevArrow:
      '<img class="arrow_left arrow_commen" src="https://cdn.shopify.com/s/files/1/1979/4109/files/chevron-left_2.svg?v=1692912421" />',
    nextArrow:
      '<img class="arrow_right arrow_commen" src="https://cdn.shopify.com/s/files/1/1979/4109/files/chevron-right_2.svg?v=1692912421" />',
    asNavFor: ".slider-nav",
  });

  $(".slider-nav").slick({
    slidesToShow: 5,
    asNavFor: ".slider-main",
    vertical: true,
    focusOnSelect: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1268,
        settings: {
          vertical: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          vertical: true,
          verticalSwiping: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  });

  $(".carousel").slick({
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
    ],
  });
});

let accHeading = document.querySelectorAll(".accordion");
let accPanel = document.querySelectorAll(".accordion-panel");

for (let i = 0; i < accHeading.length; i++) {
  accHeading[i].onclick = function () {
    if (this.nextElementSibling.style.maxHeight) {
      hidePanels();
    } else {
      showPanel(this);
    }
  };
}

function showPanel(elem) {
  hidePanels();
  elem.classList.add("active");
  elem.nextElementSibling.style.maxHeight =
    elem.nextElementSibling.scrollHeight + "px";
}

function hidePanels() {
  for (let i = 0; i < accPanel.length; i++) {
    accPanel[i].style.maxHeight = null;
    accHeading[i].classList.remove("active");
  }
}

// Handle Variant Image on Page Load

window.addEventListener("load", () => {
  let selectNoJS = document.querySelector(".main-product-wrapper .no-js");
  let selectedIndex = selectNoJS.selectedIndex;
  let selectedOption = selectNoJS.options[selectedIndex];
  let getImgId = selectedOption.getAttribute("data-imageid");
  handleVariantImageChange(getImgId);
});

let decrement = document.querySelector(".minus_selector");
let increment = document.querySelector(".plus_selector");
let qtySelector = document.querySelector(".qty_selector");
let curVal = Number(qtySelector.value);
increment.addEventListener("click", () => {
  curVal++;
  qtySelector.value = curVal;
  updateButtonState(curVal);
});

decrement.addEventListener("click", () => {
  if (curVal > 1) {
    curVal--;
    qtySelector.value = curVal;
    updateButtonState(curVal);
  }
});
function updateButtonState(quantity) {
  if (quantity === 1) {
    decrement.classList.add("disabled");
  } else {
    decrement.classList.remove("disabled");
  }
}

// mhb
let sizeSelector = document.getElementById("size-selector");
if (sizeSelector) {
  let selectedValue;
  sizeSelector.onchange = function () {
    selectedValue = sizeSelector.value;
    handleSelectedVariant(selectedValue);
  };
}
// mhb-end




let addButton = document.querySelector(".btn.btn-add");
let bisAlert = document.querySelector(".klaviyo-bis-trigger");
document
  .querySelectorAll(".variant_wrapper .variant_selector")
  .forEach((variant) => {
    variant.querySelector("label").addEventListener("click", function (lbl) {
      let inputSel = variant.querySelector("input");
      inputSel.checked = true;

      if (inputSel.checked && variant.classList.contains("disabled")) {
        addButton.classList.add("disabled");
        addButton.innerText = "Out of Stock";
        bisAlert.style.display="block";
      } else {
        addButton.classList.remove("disabled");
        addButton.innerText = "Add to Bag";
        bisAlert.style.display="none";
      }

      let variantName = variant
        .querySelector("input")
        .getAttribute("acutalname");

      handleSelectedVariant(variantName);
    });
  });

function handleSelectedVariant(variantName) {
  document
    .querySelectorAll(".product-single__variants > option")
    .forEach(function (option) {
      if (option.text === variantName) {
        option.selected = true;
        let variantNewPrice = option.getAttribute("data-variantnewprice");
        let variantOldPrice = option.getAttribute("data-variantoldprice");
        let variantId = option.value;
        handleSelectVariantShow(variantNewPrice, variantOldPrice, variantName);

        let varImageId = option.getAttribute("data-imageid");
        handleVariantImageChange(varImageId);
      }
    });
}

function handleVariantImageChange(imgId) {
  let slide_index = $(".main-product-wrapper .slider-main ." + imgId)
    .parent()
    .parent()
    .attr("data-slick-index");

  $(".main-product-wrapper .slider-main").slick("slickGoTo", slide_index);
}

function handleSelectVariantShow(
  variantNewPrice,
  variantOldPrice,
  variantName
) {
  document.querySelector(".variant_title_selector").innerHTML = variantName;

  const varNewPrice = document.querySelector(
    ".blacknwhitw-btn .discounted_price"
  );
  if (varNewPrice) {
    varNewPrice.innerHTML = variantNewPrice;
  }

  // const actualPrice = document.querySelector(
  //   ".blacknwhitw-btn .actual_price small"
  // );
  const actualPrice = document.querySelector(
    ".discounted_price"
  );

  
  if (actualPrice) {
    actualPrice.innerHTML = variantOldPrice;
  }

  const originalPrice = document.querySelector(".original_price");
  if (originalPrice) {
    originalPrice.innerHTML = variantNewPrice;
  }
}

async function updateCart() {
  const res = await fetch("/?view=cart");
  const text = await res.text();

  const html = document.createElement("div");
  html.innerHTML = text;

  // console.log({html})

  const images = html.querySelectorAll("img");
  
  images.forEach(img => {
    img.style.animation = 'fade-in 0.5s cubic-bezier(0.29, 0.65, 0.58, 1) forwards';
  });

  const newCartItems = html.querySelector(".cart__items_wrapper").innerHTML;
  const newCartDiscounts = html.querySelector(".cart__discounts").innerHTML;
  let cartSubtotalValue = html.querySelector("[data-cart-subtotal]").getAttribute("data-cart-subtotal");
  cartSubtotalValue = Number(cartSubtotalValue) / 100;

  document.querySelector("#CartDrawer [data-products]").innerHTML = newCartItems;
  document.querySelector("#CartDrawer [data-discounts]").innerHTML = newCartDiscounts;
  document.querySelector("#CartDrawer [data-subtotal]").innerHTML = '$' + cartSubtotalValue;;

  const isCartEmpty = document.querySelector(".drawer__cart-empty");
  if(isCartEmpty){
    isCartEmpty.style.display = 'none';
  }
  document.querySelector(".drawer__inner").style.display = 'flex';


  setTimeout(function(){
    document.querySelectorAll(".customCartItems .cart__item").forEach(cartItem => {
      cartItem.querySelectorAll(".js-qty__adjust").forEach(qtySingle => {
        
        qtySingle.addEventListener("click", async function (event) {
          console.log("beginning");
          console.log(event);
          const target = event.target;
          // let dataKey = cartItem.getAttribute('data-key');
          let dataKey = cartItem.getAttribute('data-vid');
          // console.log(dataKey)
          
          if (target.classList.contains("js-qty__adjust--plus")) {
            let inputQty = cartItem.querySelector(".js-qty__num");
            let updatedQty = Number(inputQty.value);
            updatedQty++;
            inputQty.value = updatedQty;
            
            // console.log("plus", dataKey, updatedQty);
            await changeQty(dataKey, updatedQty);
          }else if(target.classList.contains("js-qty__adjust--minus")){
            let inputQty = cartItem.querySelector(".js-qty__num");
            let updatedQty = Number(inputQty.value);
            if(updatedQty > 1){
              updatedQty--;
              inputQty.value = updatedQty;
              
              // console.log("minus", dataKey, updatedQty);
              await changeQty(dataKey, updatedQty);
            }else{
              let uptQty = 0;
              // console.log("less", dataKey);
              await changeQtyZero(dataKey, cartItem);
              
              // console.log("time to remove");
              let itemsLength = document.querySelectorAll(".cart__items.customCartItems > div").length;
              if(itemsLength == 0){
                document.querySelector(".drawer__cart-empty").style.display = 'block';
                document.querySelector(".drawer__inner").style.display = 'none';
              }
            }
          }

          console.log("end");
        });
      });
    });
  }, 2000); 

}

async function changeQtyZero(dataKey, cartItem){
  // console.log("less-zero", dataKey, {'id': dataKey, 'quantity': 0  }, cartItem);
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
    },
        body: JSON.stringify({ 'id': dataKey, 'quantity': 0 }),
    });
      
  const resData = await response.json();

  if(response.ok){
    cartItem.remove();
  }
  // console.log({resData})
}

async function changeQty(dataKey, updatedQty){
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
    },
        body: JSON.stringify({ 'quantity': updatedQty, 'id': dataKey }),
    });
      
  const resData = await response.json();
  // console.log({resData})

    let updatedTotalPrice = resData.total_price;
    updatedTotalPrice = Number(updatedTotalPrice) / 100;
    document.querySelector("#CartDrawer [data-subtotal]").innerHTML = '$' + updatedTotalPrice;
    //let totalDiscount = resData.total_discount;
    //totalDiscount = Number(totalDiscount) / 100;
    //document.querySelector("#CartDrawer .drawer__footer .cart__discount").innerHTML = "2023 Holiday Buy More Save More 20% (-$" + totalDiscount + ")";
}
  


document
  .getElementById("add-to-cart-btn")
  .addEventListener("click", async (e) => {
    e.preventDefault();
    try {
      let formWrapper = document.querySelector(".product-single__form");
      let formData = new FormData(formWrapper);

      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST", 
        body: formData,
      });

      const responseData = await response.json();

      await updateCart();
      document.querySelector(".js-drawer-open-cart").click();
    } catch (error) {
      console.error("Error:", error);
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  var lazyloadImages = document.querySelectorAll("img.lazy");
  var lazyloadThrottleTimeout;

  function lazyload() {
    if (lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function () {
      var scrollTop = window.pageYOffset;
      lazyloadImages.forEach(function (img) {
        if (img.offsetTop < window.innerHeight + scrollTop) {
          img.src = img.dataset.src;
          img.classList.remove("lazy");
        }
      });
      if (lazyloadImages.length == 0) {
        document.removeEventListener("scroll", lazyload);
        window.removeEventListener("resize", lazyload);
        window.removeEventListener("orientationChange", lazyload);
      }
    }, 20);
  }

  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);


  // handle discount on page load 
  const selectedOptSelected = document.querySelector(".product-single__variants.no-js option:checked");
  if (selectedOptSelected) {
    const variantOldPriceSelected = selectedOptSelected.getAttribute("data-variantoldprice");
    const variantNewPriceSelected = selectedOptSelected.getAttribute("data-variantnewprice");
    // console.log({variantOldPriceSelected, variantNewPriceSelected});

    const oldPriceNum = parseFloat(variantOldPriceSelected.replace("$", ""));
    const newPriceNum = parseFloat(variantNewPriceSelected.replace("$", ""));

    // console.log({oldPriceNum, newPriceNum})
    if(oldPriceNum > newPriceNum){
      console.log("yes old greater")
      let disPriceSelected = document.querySelector(".discounted_price");
      if(disPriceSelected){
         disPriceSelected.innerHTML = variantOldPriceSelected;
      }
    }
  }
  // end


});




